import {
  freelanceInstructorConstants,
  globalSystemConstants,
} from "../../constants";

const { BECOME_FREELANCE_INSTRUCTOR_MODAL } = freelanceInstructorConstants;

const initialState = {
  IsFreelanceInstructorModalActive: 0,
  spinnerActions: false,
};

const FreelanceInstructorReducer = (state = initialState, action) => {
  switch (action.type) {
    case BECOME_FREELANCE_INSTRUCTOR_MODAL:
      return {
        ...state,
        IsFreelanceInstructorModalActive: action.data,
      };
    case globalSystemConstants.SPINNER_ACTIVATE:
      return {
        ...state,
        spinnerActions: true,
      };
    case globalSystemConstants.SPINNER_DEACTIVATE:
      return {
        ...state,
        spinnerActions: false,
      };
    default:
      return state;
  }
};

export default FreelanceInstructorReducer;
